const HEADER_HEIGHT = '68px'

export { HEADER_HEIGHT }
